import { isEmptyString } from '@/utils/string';

/** Whether `body` is non-empty and parses as JSON. */
export function isJsonBody(body: string): boolean {
  if (isEmptyString(body)) {
    return false;
  }
  try {
    JSON.parse(body);
    return true;
  } catch {
    return false;
  }
}

/** Parse a delivery `body` JSON string, degrading to an empty object on invalid/empty input. */
function parseBody(body: string): unknown {
  try {
    return JSON.parse(body);
  } catch {
    return {};
  }
}

/** The `properties` sub-object of a parsed payload, or an empty object when absent. */
function propertiesOf(payload: unknown): unknown {
  if (payload != null && typeof payload === 'object' && 'properties' in payload) {
    return payload.properties;
  }
  return {};
}

/** Pretty-printed JSON of the whole delivery `body` payload (Ember `json-formatter` parity). */
export function formatBodyJson(body: string): string {
  return JSON.stringify(parseBody(body), null, 2);
}

/** Pretty-printed JSON of the payload's `properties` (inbox Message-tab parity). */
export function formatBodyProperties(body: string): string {
  return JSON.stringify(propertiesOf(parseBody(body)), null, 2);
}
